<template>
  <div class="home">
    <div class="title-container">
      <img src="./../assets/cfe-logo.png" style="position: relative; left: -110px; margin-bottom: 80px;" />
      <p class="title">HIV Monitoring<br />Quarterly Report</p>
      <p class="sub-title">FOR {{$route.params.ha === 'bc' ? 'BRITISH COLUMBIA' : this.$parent.haName.toUpperCase()}}</p>
      <p style="font-size: 1.5rem;">{{quarter}} QUARTER {{year}}</p>

      <!-- <div v-if="$route.params.ha !== 'bc'">
        <p><span style="font-size: 1.1rem; font-weight: bold; color: #c80000; background-color: rgba(255, 255, 0, 0.5);padding: 4px;">UPDATED VERSION: MARCH 8, 2018*</span></p>
        <p><span style="font-size: 1rem; background-color: rgba(255, 255, 0, 0.5);padding: 4px;">* Please see forward</span></p>
      </div> -->

    </div>
    <div id="using-safari" class="alert alert-warning" role="alert">
      <h4 class="alert-heading"><i class="fa fa-safari" aria-hidden="true"></i> Heads Up</h4>
      <hr>
      <h6 class="mb-0">It seems that you are using the Safari web browser. However, this website is best viewed using <a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank">Chrome</a>.</h6>
    </div>
    <table class="logos top-padded-2x" border="0">
      <tbody>
        <tr>
          <td><img class="logo-partner-1" src="./../assets/bc-cdc-logo.jpg" /></td>
          <td><img class="logo-partner-1" src="./../assets/fnha-logo.jpg" /></td>
          <td><img class="logo-partner-1" src="./../assets/fha-logo.jpg" /></td>
          <td><img class="logo-partner-1" src="./../assets/iha-logo.jpg" /></td>
        </tr>
        <tr>
          <td><img class="logo-partner-2" src="./../assets/viha-logo.jpg" /></td>
          <td><img class="logo-partner-2" src="./../assets/nha-logo.jpg" /></td>
          <td><img class="logo-partner-2" src="./../assets/phc-logo.jpg" /></td>
          <td><img class="logo-partner-2" src="./../assets/vch-logo.jpg" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  const report = require('./../../../static/report.json');
  export default {
    data () {
      let quarter = null;
      switch (Number(report.period.slice(-1))) {
        case 1:
          quarter = 'FIRST';
          break;
        case 2:
          quarter = 'SECOND';
          break;
        case 3:
          quarter = 'THIRD';
          break;
        case 4:
          quarter = 'FOURTH';
          break;
        default:
          quarter = 'Unknown';
      }
      return {
        year: report.period.substring(8, 12),
        quarter
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logos{
    table-layout: fixed;
    width: 100%;
    text-align: center;
  }

  .logos tr{
    height: 160px;
  }

  .logo-partner-1{
    height: 120px;
  }

  .logo-partner-2{
    height: 90px;
  }

  .title-container {
    width: 40em;
    margin: 0 auto 1em auto;
    padding: 1em;
  }

  .title {
    font-size: 4rem;
    font-weight: bold;
    line-height: 4rem;
  }

  .sub-title {
    font-size: 2rem;
    font-weight: bold;
    line-height: 6rem;
  }

  p.title {
    margin: 0 0 12px 0;
  }

  #using-safari {
    width: 600px;
    margin: 0 auto;
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?26e7d489